/**
 * @generated SignedSource<<6437721b47d5dde4f2a8f59cf63ac263>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AskCopilotPanelMeetingTitleFromGuidQuery$variables = {
  guid: string;
};
export type AskCopilotPanelMeetingTitleFromGuidQuery$data = {
  readonly eventByGuid: {
    readonly start: string | null;
    readonly title: string;
  } | null;
};
export type AskCopilotPanelMeetingTitleFromGuidQuery = {
  response: AskCopilotPanelMeetingTitleFromGuidQuery$data;
  variables: AskCopilotPanelMeetingTitleFromGuidQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskCopilotPanelMeetingTitleFromGuidQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskCopilotPanelMeetingTitleFromGuidQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "131506f5996726dcf2dff17f48e0bd6d",
    "id": null,
    "metadata": {},
    "name": "AskCopilotPanelMeetingTitleFromGuidQuery",
    "operationKind": "query",
    "text": "query AskCopilotPanelMeetingTitleFromGuidQuery(\n  $guid: String!\n) {\n  eventByGuid(guid: $guid) {\n    title\n    start\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "999de9761b3d43008ca7e9599ffc2604";

export default node;
